<template>
  <v-checkbox :name="item.id" :id="item.id" :rules="item.rules" :value="item.checked" light v-model="inputValue" @change="emitToParent">
    <template v-slot:label>
      <span v-html="item.text" @click.stop=""></span>
    </template>
  </v-checkbox>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'Checkbox',
  data() {
    return {
      inputValue: this.item.checked
    };
  },
  props: {
    item: Object
  },
  methods: {
    emitToParent() {
      this.$emit('childToParent', this.inputValue);
    }
  }
});
</script>

<style scoped lang="scss"></style>
